import React from 'react';
import { t, props } from 'tcomb-react';

@props({
  children: t.Arr
})
export default class StdTable extends React.Component {

  getRow([label, value], index) {
    if (t.Nil.is(value)) {
      return null;
    }
    return (
      <tr key={index}>
        <td className='std-table-label'>
          {label}
        </td>
        <td className='std-table-value'>
          {value}
        </td>
      </tr>
    );
  }

  getRows() {
    return this.props.children.map(this.getRow);
  }

  render() {
    return (
      <table className="std-table">
        <tbody>
          {this.getRows()}
        </tbody>
      </table>
    );
 }
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/StdTable.js
 **/